import type { ComponentProps } from 'react';

import type { ApiAddressWithFormData } from '#/api/types/ApiAddress';
import { FormContextConsumer } from '#/components/Form/FormContext';

import { AddressFormContainerInternal } from './AddressFormContainerInternal';

type AddressFieldsContainerProps = Omit<
  ComponentProps<typeof AddressFormContainerInternal>,
  | 'address'
  | 'clearErrors'
  | 'error'
  | 'errors'
  | 'fetchingAddress'
  | 'setFetchingAddress'
  | 'updateAddress'
>;

export function AddressFieldsContainer({
  index,
  ...restProps
}: AddressFieldsContainerProps) {
  const addressKey = index !== undefined ? `addresses.${index}` : 'address';
  return (
    <FormContextConsumer>
      {({
        clearErrors,
        updateValueWith,
        fetchingAddress,
        setFetchingAddress,
        errors,
        getValue,
      }) => (
        <AddressFormContainerInternal
          index={index}
          address={
            getValue(addressKey) as ApiAddressWithFormData | null | undefined
          }
          fetchingAddress={fetchingAddress}
          setFetchingAddress={setFetchingAddress}
          updateAddress={(update) => {
            updateValueWith(addressKey, (a: Record<string, unknown>) => ({
              ...a,
              ...update,
            }));
          }}
          clearErrors={clearErrors}
          error={errors[addressKey]}
          errors={errors}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...restProps}
        />
      )}
    </FormContextConsumer>
  );
}
